var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowAccordion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.15816,
    cy: 8.3984,
    r: 8.335,
    transform: "rotate(180 9.15816 8.3984)",
    fill: "#0AA8E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_692_19061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72457 11.3951C9.58584 11.5508 9.37774 11.6545 9.16964 11.6545C8.96154 11.6545 8.75345 11.5508 8.61472 11.3951L4.3834 6.64747C4.08281 6.31021 4.08281 5.73945 4.3834 5.40219C4.68398 5.06492 5.19267 5.06492 5.49325 5.40219L9.16964 9.50124L12.8229 5.40219C12.9848 5.22059 13.1697 5.14276 13.3778 5.14276C13.5859 5.14276 13.794 5.22059 13.9328 5.40219C14.2333 5.73945 14.2333 6.31021 13.9328 6.64747L9.72457 11.3951Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_692_19061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.0002,
    height: 11.5119,
    fill: "white",
    transform: "translate(4.1582 2.64258)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowAccordion);
export default __webpack_public_path__ + "static/media/ic-arrow-accordion.a7127521efb3683552df228454837453.svg";
export { ForwardRef as ReactComponent };